import React from 'react';

const Step2Constitution = ({ formData, updateFormData, onNext, onPrev }) => {
  const handleRadioChange = (field, value) => {
    updateFormData(field, value);
    
    // Reset dependent fields when changing main questions
    if (field === 'constitutionOptimized') {
      updateFormData('constitutionActionSteps', '');
    }
    if (field === 'bulletproofTest') {
      updateFormData('bulletproofActionSteps', '');
    }
  };

  const canProceed = () => {
    return formData.constitutionOptimized !== null &&
           formData.bulletproofTest !== null &&
           ((formData.constitutionOptimized === true) || 
            (formData.constitutionOptimized === false && formData.constitutionActionSteps.trim() !== '')) &&
           ((formData.bulletproofTest === true) || 
            (formData.bulletproofTest === false && formData.bulletproofActionSteps.trim() !== ''));
  };

  return (
    <div className="step-content">
      <h2 className="step-title">Step 2: Constitution Optimization</h2>
      
      {/* 2.1 Constitution Check */}
      <div className="question-container">
        <h3 style={{ marginBottom: '20px', color: '#333', fontSize: '1.3rem' }}>
          2.1 Constitution Check
        </h3>
        
        <div className="question-text">
          Is your business structure (entity, compliance, governance) optimized for your needs?
        </div>
        
        <div className="radio-group">
          <div 
            className={`radio-option ${formData.constitutionOptimized === true ? 'selected' : ''}`}
            onClick={() => handleRadioChange('constitutionOptimized', true)}
          >
            <input
              type="radio"
              name="constitutionOptimized"
              checked={formData.constitutionOptimized === true}
              onChange={() => {}}
            />
            <label>Yes</label>
          </div>
          <div 
            className={`radio-option ${formData.constitutionOptimized === false ? 'selected' : ''}`}
            onClick={() => handleRadioChange('constitutionOptimized', false)}
          >
            <input
              type="radio"
              name="constitutionOptimized"
              checked={formData.constitutionOptimized === false}
              onChange={() => {}}
            />
            <label>No</label>
          </div>
        </div>

        {/* Action input if constitution is not optimized */}
        {formData.constitutionOptimized === false && (
          <div className="action-input-container">
            <div className="action-input-label">
              Please write down steps to optimize your constitution.
            </div>
            <textarea
              className="action-textarea"
              value={formData.constitutionActionSteps}
              onChange={(e) => updateFormData('constitutionActionSteps', e.target.value)}
              placeholder="Enter your action steps here..."
            />
          </div>
        )}
      </div>

      {/* 2.2 Bulletproof Test */}
      <div className="question-container">
        <h3 style={{ marginBottom: '20px', color: '#333', fontSize: '1.3rem' }}>
          2.2 Bulletproof Test
        </h3>
        
        <div className="info-note">
          <div className="info-note-text">
            <strong>A Bulletproof Tax Structure is: Aligned, Simple, and Exit-Efficient.</strong>
          </div>
        </div>
        
        <div className="question-text">
          Does your business structure pass the Bulletproof Test?
        </div>
        
        <div className="radio-group">
          <div 
            className={`radio-option ${formData.bulletproofTest === true ? 'selected' : ''}`}
            onClick={() => handleRadioChange('bulletproofTest', true)}
          >
            <input
              type="radio"
              name="bulletproofTest"
              checked={formData.bulletproofTest === true}
              onChange={() => {}}
            />
            <label>Yes</label>
          </div>
          <div 
            className={`radio-option ${formData.bulletproofTest === false ? 'selected' : ''}`}
            onClick={() => handleRadioChange('bulletproofTest', false)}
          >
            <input
              type="radio"
              name="bulletproofTest"
              checked={formData.bulletproofTest === false}
              onChange={() => {}}
            />
            <label>No</label>
          </div>
        </div>

        {/* Show message or action input based on answer */}
        {formData.bulletproofTest === true && (
          <div style={{ 
            background: '#e8f5e8', 
            padding: '15px', 
            borderRadius: '8px', 
            marginTop: '20px',
            borderLeft: '3px solid #4CAF50'
          }}>
            <strong style={{ color: '#2e7d32' }}>Great! Proceed to Tactical Strategies.</strong>
          </div>
        )}

        {formData.bulletproofTest === false && (
          <div className="action-input-container">
            <div className="action-input-label">
              Please write down steps to make your structure bulletproof.
            </div>
            <textarea
              className="action-textarea"
              value={formData.bulletproofActionSteps}
              onChange={(e) => updateFormData('bulletproofActionSteps', e.target.value)}
              placeholder="Enter your action steps here..."
            />
          </div>
        )}
      </div>

      {/* Navigation */}
      <div className="navigation-buttons">
        <button
          className="btn btn-secondary"
          onClick={onPrev}
        >
          ← Back to Alignment
        </button>
        <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={!canProceed()}
        >
          Continue to Tactical Strategies
        </button>
      </div>
    </div>
  );
};

export default Step2Constitution;
